<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="500px"
    :title="$l('btn_export_batch') || '导出批次信息'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <div class="print_btn_group">
      <el-button plain @click="exportExcel('one')">
        {{ $l('btn_Template_One') || '模版一' }}
      </el-button>
      <el-button plain @click="exportExcel('two')">
        {{ $l('btn_Template_Two') || '模版二' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    orderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    async exportExcel(type) {
      const parms = { orderCode: this.orderCode }
      this.loadingOpen()
      const checkRes = await this.$api
        .orderBatchGoodsCheckDataApi(parms)
        .catch(() => null)
      const { status, msg } = checkRes || {}
      if (status != 200) {
        this.loadingClose()
        this.$message.error(msg)
        return
      }

      const context = { ...parms, type, mode: 'A' }
      const exportRes = await this.$api
        .SYS_EXPORT_TASK('factory-order-batch', context)
        .catch(() => null)
      this.loadingClose()
      const { status: exportStatus } = exportRes || {}
      if (exportStatus !== 200) {
        this.$message.error(
          this.$l('Description_Failed_to_add_export_task') || '导出任务添加失败'
        )
        return
      }
      this.$message({
        message:
          this.$l('added_to_the_download_center') ||
          '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
        type: 'success',
      })
      this.close()
    },
  },
}
</script>
<style lang="scss" scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
